import React, { useState, useEffect } from "react";
import "./index.css";
import "./holdings.css";
import profile from "../../../assets/images/profile.png";
import { Phone, UserPlus, TrendingUp } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { offices } from "../../contact-us/index";
import {
  demoUserHolding,
  demoUserDetails,
  resetFunds,
} from "../../../services/demouser";
import { Button } from "bootstrap";
import { fireToastMessage } from "../../toastContainer";
// Accordion Component
const DummyAccordion = ({ title, data }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="dummy-profile-accordion">
      <div
        className="dummy-profile-accordion-header"
        onClick={() => setOpen(!open)}
      >
        <h3>{title}</h3>
        <span>{open ? "-" : "+"}</span>
      </div>
      {open && (
        <div className="dummy-profile-accordion-content">
          {data.map((item, index) => (
            <div className="dummy-profile-accordion-row" key={index}>
              <p>{item.key}</p>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Dummy Data
const marginUtilizationData = [
  { key: "Margin Utilization", value: "PKR 0.00" },
  { key: "Net Equity (Margin)", value: "1,000,000.00" },
  { key: "Available Margin", value: "1,000,000.00" },
  { key: "Pending Cash Withdrawal", value: "0.00" },
  { key: "Buying Power FUT", value: "120,000.00" },
  { key: "Buying Power LB", value: "210,000.00" },
  { key: "Open Positions", value: "0.00" },
  { key: "Pending Orders", value: "0.00" },
  { key: "Trading Limit", value: "1,000,000.00" },
  { key: "Cash Withdrawal Limit", value: "1,000,000.00" },
  { key: "Margin Blocked", value: "0.00" },
  { key: "MTM Losses", value: "0.00" },
  { key: "Cash Margin Call", value: "0.00" },
  { key: "Cash Margin Required", value: "0.00" },
  { key: "Blocked MTM Profit", value: "0.00" },
  { key: "Margin Call", value: "0.00" },
  { key: "Margin Utilization", value: "0.00" },
];

const netEquityData = [
  { key: "Opening Cash Balance", value: "PKR 1,000,000.00" },
  { key: "Eq. Floating Cash Bal.", value: "1,000,000.00" },
  { key: "Commodity Cash Balance", value: "0.00" },
  { key: "Total Payable", value: "0.00" },
  { key: "Market Value of Portfolio", value: "0.00" },
  { key: "MFS Blocked Profit", value: "0.00" },
  { key: "Total Worth", value: "1,000,000.00" },
  { key: "Portfolio after Haircut", value: "0.00" },
  { key: "Net Equity (Margin)", value: "1,000,000.00" },
];

// User Details Component
const UserDetails = ({ userDetails }) => {
  return (
    <div className="user-details-section">
      <div className="user-details-header">
        <h3>User Information</h3>
      </div>

      <div className="user-details-grid">
        {/* <div className="user-detail-card">
          <div className="user-detail-icon">
            <UserPlus size={24} />
          </div>
          <div className="user-detail-content">
            <h4>Personal Information</h4>
            <div className="user-detail-row">
              <span className="detail-label">Name:</span>
              <span className="detail-value">{userDetails.name || "N/A"}</span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{userDetails.email || "N/A"}</span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">User ID:</span>
              <span className="detail-value">{userDetails._id || "N/A"}</span>
            </div>
          </div>
        </div> */}

        <div className="user-detail-card">
          <div className="user-detail-icon">
            <TrendingUp size={24} />
          </div>
          <div className="user-detail-content">
            <h4>Account Balance</h4>
            <div className="user-detail-row">
              <span className="detail-label">Available Funds:</span>
              <span className="detail-value fund-amount">
                PKR{" "}
                {userDetails.funds
                  ? userDetails.funds.toLocaleString()
                  : "0.00"}
              </span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">Account Type:</span>
              <span className="detail-value">
                {userDetails.accountType || "Demo Account"}
              </span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">Status:</span>
              <span className="detail-value status-active">
                {userDetails.status || "Active"}
              </span>
            </div>
          </div>
        </div>

        <div className="user-detail-card">
          <div className="user-detail-icon">
            <Phone size={24} />
          </div>
          <div className="user-detail-content">
            <h4>Account Details</h4>
            <div className="user-detail-row">
              <span className="detail-label">Created:</span>
              <span className="detail-value">
                {userDetails.createdAt
                  ? new Date(userDetails.createdAt).toLocaleDateString()
                  : "N/A"}
              </span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">Last Updated:</span>
              <span className="detail-value">
                {userDetails.updatedAt
                  ? new Date(userDetails.updatedAt).toLocaleDateString()
                  : "N/A"}
              </span>
            </div>
            <div className="user-detail-row">
              <span className="detail-label">Phone:</span>
              <span className="detail-value">{userDetails.phone || "N/A"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Holdings Component
const UserHoldings = () => {
  const [holdings, setHoldings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useHistory();

  useEffect(() => {
    const fetchHoldings = async () => {
      try {
        setLoading(true);
        const response = await demoUserHolding();
        setHoldings(response || []);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        setError("Failed to load holdings");
      } finally {
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []);

  const handleStockClick = (symbol) => {
    navigate.push(`/trading-details/${symbol}`);
  };

  if (loading) {
    return (
      <div className="holdings-section">
        <h3>My Holdings</h3>
        <div className="holdings-loading">Loading holdings...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="holdings-section">
        <h3>My Holdings</h3>
        <div className="holdings-error">{error}</div>
      </div>
    );
  }

  if (!holdings || holdings.length === 0) {
    return (
      <div className="holdings-section">
        <h3>My Holdings</h3>
        <div className="holdings-empty">No holdings found</div>
      </div>
    );
  }

  const totalInvestment =
    holdings.length &&
    holdings?.reduce(
      (total, holding) => total + holding.quantity * holding.avgBuyPrice,
      0
    );

  return (
    <div className="holdings-section">
      <div className="holdings-header">
        <h3>My Holdings ({holdings.length})</h3>
        <div className="holdings-total">
          <span>
            Total Investment:{" "}
            <strong>PKR {totalInvestment?.toLocaleString()}</strong>
          </span>
        </div>
      </div>

      <div className="holdings-grid">
        {holdings.map((holding, index) => (
          <div
            key={holding._id || index}
            className="holding-card"
            onClick={() => handleStockClick(holding.symbol)}
          >
            <div className="holding-card-header">
              <div className="holding-symbol">
                <TrendingUp size={20} />
                <strong>{holding.symbol}</strong>
              </div>
              <div className="holding-id">ID: {holding._id.slice(-6)}</div>
            </div>

            <div className="holding-details">
              <div className="holding-detail-row">
                <span>Quantity:</span>
                <strong>{holding.quantity}</strong>
              </div>
              <div className="holding-detail-row">
                <span>Avg Price:</span>
                <strong>PKR {holding.avgBuyPrice}</strong>
              </div>
              <div className="holding-detail-row">
                <span>Total Value:</span>
                <strong>
                  PKR {(holding.quantity * holding.avgBuyPrice).toFixed(2)}
                </strong>
              </div>
              <div className="holding-detail-row">
                <span>Added:</span>
                <span>{new Date(holding.createdAt).toLocaleDateString()}</span>
              </div>
            </div>

            <div className="holding-card-footer">
              <small>User ID: {holding.userId.slice(-6)}</small>
              <small>
                Updated: {new Date(holding.updatedAt).toLocaleDateString()}
              </small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const DummyProfile = () => {
  const navigate = useHistory();
  const [showOfficeModal, setShowOfficeModal] = useState(false);
  const [activeOffice, setActiveOffice] = useState(0);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setLoading(true);
        const response = await demoUserDetails();
        setUserDetails(response);
      } catch (err) {
        console.error("Error fetching user details:", err);
        setError("Failed to load user details");
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  const handleResetFunds = async () => {
    try {
      setResetLoading(true);
      const response = await resetFunds();

      // Update user details after successful reset
      const updatedUserDetails = await demoUserDetails();
      setUserDetails(updatedUserDetails);

      fireToastMessage({
        type: "success",
        message:
          "Funds reset successfully! Your account has been restored to the default balance.",
      });

      console.log("Reset funds response:", response);
    } catch (error) {
      console.error("Error resetting funds:", error);
      fireToastMessage({
        type: "error",
        message: "Failed to reset funds. Please try again later.",
      });
    } finally {
      setResetLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="user-details-section">
        <h3>User Information</h3>
        <div className="user-details-loading">Loading user details...</div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="user-details-section">
        <h3>User Information</h3>
        <div className="user-details-error">{error}</div>
      </div>
    );
  }
  return (
    <div className="dummy-profile-container">
      {/* Row 1: Profile Section */}
      <div className="dummy-profile-header">
        <div className="dummy-profile-info">
          <img src={profile} alt="Profile" className="dummy-profile-img" />
          <div>
            <p className="dummy-profile-name">{userDetails.name}</p>
            <p className="dummy-profile-email">{userDetails.email}</p>
          </div>
        </div>
        <select className="dummy-profile-dropdown">
          <option>Option 1</option>
          <option>Option 2</option>
        </select>
      </div>

      {/* Row 2: User Details Section */}
      <UserDetails userDetails={userDetails} />

      {/* Row 3: Ledger Balance Section */}
      <div className="dummy-profile-ledger">
        <div>
          <p className="dummy-profile-ledger-title">Ledger Balance</p>
          <p className="dummy-profile-ledger-amount">PKR {userDetails.funds}</p>
        </div>
        <div className="">
          <button
            className="dummy-profile-view-details"
            onClick={handleResetFunds}
            disabled={resetLoading}
            type="button"
          >
            {resetLoading ? "Resetting..." : "Reset Funds"}
          </button>
          <NavLink to="/demo-details">
            <button className="dummy-profile-view-details">View Details</button>
          </NavLink>
        </div>
      </div>

      {/* Row 3: Two Accordions */}
      <div className="dummy-profile-accordions">
        {/* Accordion 1 */}
        <DummyAccordion
          title="Margin Utilization"
          data={marginUtilizationData}
        />

        {/* Accordion 2 */}
        <DummyAccordion title="Net Equity (Margin)" data={netEquityData} />
      </div>

      <div className="dummy-profile-new-section">
        {/* Column 1: Buttons */}
        <div className="dummy-profile-buttons">
          <div>
            <button
              onClick={() => navigate.push("/create-account")}
              className="dummy-profile-btn"
            >
              <UserPlus size={18} />
            </button>
            <p>Open Account</p>
          </div>
          <div>
            <button
              onClick={() => setShowOfficeModal(true)}
              className="dummy-profile-btn"
            >
              <Phone size={18} />
            </button>
            <p>Contact Us</p>
          </div>
        </div>

        {/* Column 2: Portfolio Holdings */}
        <div className="dummy-profile-portfolio-heading">
          <h3>Portfolio Holdings</h3>
        </div>

        {/* Column 3: Values */}
        <div className="dummy-profile-values">
          <div className="dummy-profile-value">
            <p>Investment Value</p>
            <p>PKR 500,000.00</p>
          </div>
          <div className="dummy-profile-value">
            <p>Current Value</p>
            <p>PKR 550,000.00</p>
          </div>
          <div className="dummy-profile-value">
            <p>Realised P/L</p>
            <p>PKR 50,000.00</p>
          </div>
        </div>
      </div>

      {/* User Holdings Section */}
      <UserHoldings />

      <Modal
        show={showOfficeModal}
        onHide={() => setShowOfficeModal(false)}
        centered
        size="lg"
        dialogClassName="dummy-modal-wrapper"
      >
        <Modal.Header closeButton className="dummy-modal-header">
          <Modal.Title className="dummy-modal-title">
            Contact Information
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="dummy-modal-body">
          <div className="dummy-modal-content-container">
            <div className="dummy-modal-details">
              <h5 className="dummy-modal-office-name">
                {offices[activeOffice].name}
              </h5>
              <p>
                <strong>Address:</strong> {offices[activeOffice].address}
              </p>
              <p>
                <strong>Phone:</strong> {offices[activeOffice].phone}
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href={`mailto:${offices[activeOffice].email}`}
                  className="dummy-modal-email-link"
                >
                  {offices[activeOffice].email}
                </a>
              </p>
            </div>

            <div className="dummy-modal-map">
              <iframe
                src={offices[activeOffice].mapSrc}
                className="dummy-modal-map-frame"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Google Map - ${offices[activeOffice].name}`}
              ></iframe>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="dummy-modal-footer">
          <div className="dummy-modal-switch-btns">
            {offices.map((office, index) => (
              <button
                key={index}
                className={`dummy-modal-switch-btn ${
                  activeOffice === index ? "active" : ""
                }`}
                onClick={() => setActiveOffice(index)}
              >
                {office.name}
              </button>
            ))}
          </div>
          <button
            className="dummy-modal-close-btn"
            onClick={() => setShowOfficeModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
